(function () {
  "use strict";

  var reduce = window.matchMedia
    ? window.matchMedia("(prefers-reduced-motion: reduce)")
    : null;

  var setEdges = function (track) {
    track.__auTick = false;
    var max = track.scrollWidth - track.clientWidth;
    var rail = track.parentNode;
    var prev = rail.querySelector("[data-au-rail-prev]");
    var next = rail.querySelector("[data-au-rail-next]");
    var atStart = track.scrollLeft <= 2 ? "true" : "false";
    var atEnd = track.scrollLeft >= max - 2 ? "true" : "false";
    if (prev && prev.getAttribute("aria-disabled") !== atStart) {
      prev.setAttribute("aria-disabled", atStart);
    }
    if (next && next.getAttribute("aria-disabled") !== atEnd) {
      next.setAttribute("aria-disabled", atEnd);
    }
    var dots = rail.querySelectorAll(".au-card-rail__dot");
    if (dots.length) {
      var active = max > 0 ? Math.round((track.scrollLeft / max) * (dots.length - 1)) : 0;
      dots.forEach(function (dot, i) {
        dot.toggleAttribute("data-active", i === active);
      });
    }
  };

  document.addEventListener(
    "scroll",
    function (e) {
      var t = e.target;
      if (!t || !t.hasAttribute || !t.hasAttribute("data-au-rail-track")) return;
      if (t.__auTick) return;
      t.__auTick = true;
      requestAnimationFrame(function () {
        setEdges(t);
      });
    },
    { capture: true, passive: true }
  );

  var refresh = function () {
    document.querySelectorAll("[data-au-rail-track]").forEach(setEdges);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", refresh);
  else refresh();
  window.addEventListener("load", refresh);
  window.addEventListener("resize", refresh);
  window.addEventListener("theme:drawer:open", function () {
    setTimeout(refresh, 350);
  });

  document.addEventListener("click", function (e) {
    var btn =
      e.target.closest &&
      e.target.closest("[data-au-rail-prev],[data-au-rail-next]");
    var cell = !btn && e.target.closest && !e.target.closest("a, button, input, select, textarea, label, summary") && e.target.closest(".text-columns--root .au-card-rail__cell");
    if (cell) {
      var cellRail = cell.closest(".au-card-rail");
      var cellTrack = cellRail && cellRail.querySelector("[data-au-rail-track]");
      if (!cellTrack || cellTrack.scrollWidth - cellTrack.clientWidth < 2) return;
      if (cellTrack.scrollLeft >= cellTrack.scrollWidth - cellTrack.clientWidth - 2) {
        cellTrack.scrollTo({ left: 0, behavior: reduce && reduce.matches ? "auto" : "smooth" });
        return;
      }
      btn = cellRail.querySelector("[data-au-rail-next]");
    }
    if (!btn) return;

    var rail = btn.closest(".au-card-rail");
    var track = rail && rail.querySelector("[data-au-rail-track]");
    if (!track) return;

    var cells = track.children;
    var step = track.clientWidth;
    if (cells.length > 1) {
      step = cells[1].offsetLeft - cells[0].offsetLeft;
    } else if (cells.length === 1) {
      step = cells[0].getBoundingClientRect().width;
    }
    if (!(step > 0)) step = track.clientWidth;

    track.scrollBy({
      left: (btn.hasAttribute("data-au-rail-prev") ? -1 : 1) * step,
      behavior: reduce && reduce.matches ? "auto" : "smooth",
    });
  });
})();
